/**
 * ChromeLayer — the always-on phone-frame chrome the modal wraps every
 * preview in. Sits at z-index 6 so it stacks above the page-transition
 * stage (≤5) but below the intro / respond dialog (10+) and player
 * controls.
 */
import type { CSSProperties, ReactNode } from 'react';

export interface ChromeLayerProps {
  children: ReactNode;
  /** Slight inset so the 2.5rem rounded corners are visible. */
  className?: string;
  style?: CSSProperties;
}

export function ChromeLayer({ children, className, style }: ChromeLayerProps) {
  return (
    <div
      className={[
        'relative h-full w-full overflow-hidden rounded-[2.5rem] bg-zinc-950',
        'shadow-[0_30px_80px_-20px_rgba(255,107,157,0.4)]',
        className ?? '',
      ]
        .filter(Boolean)
        .join(' ')}
      style={style}
    >
      {children}
    </div>
  );
}
